import { render } from "./EditCounselor.vue?vue&type=template&id=3443a1ef&scoped=true"
import script from "./EditCounselor.vue?vue&type=script&lang=js"
export * from "./EditCounselor.vue?vue&type=script&lang=js"

import "./EditCounselor.vue?vue&type=style&index=0&id=3443a1ef&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3443a1ef"

export default script